import React from "react";
import alertIcon from "../../../../assests/img/alert-icons.svg";
import ModalContainer from "Components/Common/Modal/ModalContainer";
import ModalBody from "Components/Common/Modal/ModalBody";
import ModalHeader from "Components/Common/Modal/ModalHeader";
import FillButton from "Components/Common/components/Button/FillButton";
import BorderedButton from "Components/Common/components/Button/BorderedButton";

const DeleteProjectModal = ({ showModal, closeModal, onConfirm, loading, deleteItem }: any) => {
    return (
        <ModalContainer
            isOpen={showModal}
            setOpen={closeModal}>
            <ModalHeader>
                <div id="delete-modal-header" className="tw-py-2">
                    <h5 id="delete-modal-title" className="tw-text-xl tw-font-bold">
                        Delete &quot;{deleteItem?.name}&quot;
                    </h5> 
                </div>
            </ModalHeader>
            <ModalBody>
                <div id="delete-modal-content" className="tw-space-y-3 tw-py-4">
                    <div id="delete-warning-box" className="tw-bg-red-50 tw-flex tw-space-x-3 tw-items-center tw-p-2 tw-px-3 tw-rounded ">
                        <img 
                            id="delete-warning-icon" 
                            className="alert-icons" 
                            src={alertIcon} 
                            alt="Alert icon" 
                        />
                        <p id="delete-warning-text">
                            This action will permanently delete &quot;{deleteItem?.name}&quot;, and it cannot be undone.
                        </p>
                    </div>
                    <center>
                        <p id="delete-confirmation-text">Would you like to proceed?</p>
                    </center>
                    <div id="delete-modal-actions" className="tw-flex tw-justify-center tw-space-x-3">
                        <BorderedButton 
                            id="delete-cancel-btn"
                            onClick={() => closeModal()}
                        >
                            Cancel
                        </BorderedButton>
                        <FillButton 
                            id="delete-confirm-btn"
                            className={`!tw-border-red-500 !tw-cursor-pointer !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`} 
                            onClick={() => onConfirm()} 
                            disabledClassName="!tw-border-red-200 !tw-bg-red-200" 
                            disabled={loading}
                        >
                            Delete
                        </FillButton>
                    </div>
                </div>
            </ModalBody>
        </ModalContainer>
    );
};

export default DeleteProjectModal;